module.exports = __webpack_public_path__ + "img/icon_proveedores.cc7d0630.svg";